import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import relatoriosDisponibilidadeStore from '../_store'

import { validateComputed, validateData } from '../_validates'

export const relatoriosDisponibilidadeMixins = {
  data: () => ({
    showSkeleton: false,
    showSkeletonForm: false,
    selectByDepartament: false,
    operadores: [],
    operadoresAtivos: [],
    todosOperadores: [],
    departamentos: [],
    departamentosSelecionados: [],
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('relatoriosDisponibilidadeStore', ['getAgents', 'getDepartament']),
    ...validateComputed,

    todosOperadoresSelecionados() {
      return this.form.operadores.length === this.operadores.length
    },
    algunsOperadoresSelecionados() {
      return this.form.operadores.length > 0 && !this.todosOperadoresSelecionados
    },
    icon() {
      if (this.todosOperadoresSelecionados) return 'mdi-close-box'
      if (this.algunsOperadoresSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    somenteOperadoresAtivos(){
      return this.operadores.length === this.operadoresAtivos.length
    },

    iconOperadoresAtivos() {
      if (this.somenteOperadoresAtivos) return 'mdi-close-box'
      return 'mdi-checkbox-blank-outline'
    },


    todosDepartamentosSelecionados() {
      return this.departamentosSelecionados.length === this.departamentos.length
    },
    algunsDepartamentosSelecionados() {
      return this.departamentosSelecionados.length > 0 && !this.todosDepartamentosSelecionados
    },
    iconDepartamento() {
      if (this.todosDepartamentosSelecionados) return 'mdi-close-box'
      if (this.algunsDepartamentosSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    departamentoEhVazio(){
      if(this.operadoresDoDepartamento.length == 0){
        return true
      }else{
        return this.operadoresDoDepartamento.filter(value => value.length !== 0)
      }
    },

    operadoresDoDepartamento(){
      var agents = []
      if(this.departamentosSelecionados !== undefined){
        this.departamentosSelecionados.forEach(id =>{
          this.getDepartament.forEach(departamentos =>{
            if(id == departamentos._id){
              agents.push(departamentos.agentsDepartamento)
            }
          })
        })
      }
      return agents
    },


    departamentosParaAgents(){
      var agents = []
      this.getDepartament.forEach(departament =>{
        departament.agentsDepartamento.forEach(agent =>{
          let teste = {
            text: `${agent.numero} - ${agent.usuario}` ,
            value: agent._id,
          }
          if(!agents.some(e => e.value == agent._id)){
            agents.push(teste)
          }
        })
      })
      return agents
    }
  },

  async created() {
    this.showSkeletonForm = true

    registerVuexModule(this.$store, 'relatoriosDisponibilidadeStore', relatoriosDisponibilidadeStore)

    await Promise.all([this.listarOperadores(),  this.listarDepartamento()])

    this.operadores = this.getAgents.map(operador => ({
      value: operador._id,
      text: `${ (!operador.active) ? 
        `${operador.numero} - ${operador.usuario} - Desativado `: 
        `${operador.numero} - ${operador.usuario}`}`,
      // disabled: !operador.active,
    }))
    this.operadoresAtivos = this.getAgents.filter(operador=>operador.active == true).map(operador => ({
      value: operador._id,
      text:`${operador.numero} - ${operador.usuario}`,
    }))
    this.todosOperadores = this.operadores;
    

    this.departamentos = this.getDepartament.map(departament =>({
      text: `${departament.codigo} - ${departament.description}`,
      value: departament._id,
    }))

    this.departamentos.sort((a,b) => a.text.localeCompare(b.text, undefined, { numeric: true }));

    this.showSkeletonForm = false
  },

  methods: {
    ...mapActions('relatoriosDisponibilidadeStore', [ 'listarOperadores', 'listarDepartamento']),
    toggle() {
      this.$nextTick(() => {
        if (this.todosOperadoresSelecionados) {
          this.form.operadores.splice(0)
        } else {
          this.form.operadores.splice(0)
          this.form.operadores = this.operadores.map(operador => operador.value)
        }
      })
    },

    toggleDepartamento(){
      this.$nextTick(() => {
        if (this.todosDepartamentosSelecionados) {
          this.departamentosSelecionados.splice(0)
        } else {
          this.departamentosSelecionados.splice(0)
          this.departamentosSelecionados = this.departamentos.map(departament => departament.value)
        }
      })
    },
    
    toggleOperadoresAtivos() {
      this.$nextTick(() => {
        if(!this.somenteOperadoresAtivos){
          this.operadores = this.operadoresAtivos;
        }else{
          this.operadores = this.todosOperadores;
        }
      })
    },


    filtraAgentPorDepartamento(departamentoSelected){
      this.form.operadores.splice(0)
      departamentoSelected.forEach(departamento =>{
        departamento.forEach(operadores =>{
          if(!(this.form.operadores == undefined))
          {
            if((this.form.operadores.findIndex(operadorForm => operadorForm === operadores._id)) === -1){
              this.form.operadores.push(operadores._id)
            }
          }
        })   
      })
    },
    
  },
  
  watch: {
    departamentosSelecionados: function() {
      this.filtraAgentPorDepartamento(this.operadoresDoDepartamento)
    },
  },

}
